import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  root: {
    fontSize: '12px',
    padding: '16px 32px'
  }
}))
